import { CalendarIconElement } from "components/input/date/calendarIconElement";
import { InputHTMLElement } from "./baseHTMLElementInput";
import i18n from "components/i18n/i18n";
import $ from "jquery";
import IMask from "imask";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";

export abstract class DateInputHTMLElement extends InputHTMLElement {

    private _dateRangePicker: any;
    private _dateRangePickerOptions: any;
    private _mask: IMask.InputMask<IMask.MaskedDateOptions> | IMask.InputMask<IMask.AnyMaskedOptions>;
    private _maskOptions: IMask.MaskedDateOptions | IMask.AnyMaskedOptions;
    private _clearButton: HTMLElement;
    private _calendarIcon: CalendarIconElement;

    private _invalidDateDaysOfWeeks: number[] = null;
    private _separatorRange: string

    constructor() {
        super();
        this._separatorRange = i18n.instance.t("daterangepicker.locale.separator");

        const invalidDateDaysOfWeeks = this.getAttribute("invalidDateDaysOfWeeks");
        if (invalidDateDaysOfWeeks) {
            this.invalidDateDaysOfWeeks = invalidDateDaysOfWeeks.split(',').map(Number);
        }
    }


    public set dateRangePicker(dateRangePicker: any) {
        this._dateRangePicker = dateRangePicker;
    }

    public get dateRangePicker(): any {
        return this._dateRangePicker;
    }

    public set dateRangePickerOptions(dateRangePickerOptions: any) {
        this._dateRangePickerOptions = dateRangePickerOptions;
    }

    public get dateRangePickerOptions(): any {
        return this._dateRangePickerOptions;
    }

    public set mask(mask: IMask.InputMask<IMask.MaskedDateOptions> | IMask.InputMask<IMask.AnyMaskedOptions>) {
        this._mask = mask;
    }

    public get mask(): IMask.InputMask<IMask.MaskedDateOptions> | IMask.InputMask<IMask.AnyMaskedOptions> {
        return this._mask;
    }

    public set maskOptions(maskOptions: IMask.MaskedDateOptions | IMask.AnyMaskedOptions) {
        this._maskOptions = maskOptions;
    }

    public get maskOptions(): IMask.MaskedDateOptions | IMask.AnyMaskedOptions {
        return this._maskOptions;
    }

    public set clearButton(clearButton: HTMLElement) {
        this._clearButton = clearButton;
    }

    public get clearButton(): HTMLElement {
        return this._clearButton;
    }

    public set calendarIcon(calendarIcon: CalendarIconElement) {
        this._calendarIcon = calendarIcon;
    }

    public get calendarIcon(): CalendarIconElement {
        return this._calendarIcon;
    }

    public get separatorRange(): string {
        return this._separatorRange;
    }

    public set invalidDateDaysOfWeeks(invalidDateDaysOfWeeks: number[]) {
        this._invalidDateDaysOfWeeks = invalidDateDaysOfWeeks;
    }

    public get invalidDateDaysOfWeeks(): number[] {
        return this._invalidDateDaysOfWeeks;
    }

    public bindEvents(): void {
        this.bindEventsInput();
        this.bindEventsClearButton();
        this.bindEventsCalendarIcon();
    }

    private bindEventsInput() {
        super.genericBindEvents();
        this.input.addEventListener("blur", (evt) => {
            this.mask?.updateOptions({ ...this.maskOptions, lazy: true })
        });
        this.input.addEventListener("focus", (evt) => {
            this.initializeDateRangePickerWithIMask();
            this.mask?.updateOptions({ ...this.maskOptions, lazy: false });
            if (this.mask != null) {
                const input = (<HTMLInputElement>evt.target);
                input.setSelectionRange(0, (this.mask.unmaskedValue === "") ? 0 : input.value.length);
            }
        });
    }

    private bindEventsCalendarIcon() {
        this.calendarIcon.addEventListener("click", () => {
            this.initializeDateRangePickerWithIMask();
            this.input.focus();
        });
    }

    private bindEventsClearButton() {
        this.clearButton.style.visibility = "hidden";
        this.clearButton.addEventListener("click", () => {
            this.input.value = null;
            this.mask?.updateValue();
            this.setClearButtonVisibility();
            this.dispatchEvent(new Event('change'));
        });
    }

    private initializeDateRangePickerWithIMask() {
        if (this.dateRangePicker == null) {
            this.defineDateRangePickerOptions();
            this.initializeDateRangePicker();
        }
        if (this.mask == null) {
            this.defineIMaskOptions();
            this.initializeIMask();
        }
    }

    public addDateRangePickerOptionIsInvalidDate() {

        if (this.dateRangePickerOptions) {
            if (this.invalidDateDaysOfWeeks && this.invalidDateDaysOfWeeks.length > 0) {
                const invalidDateDaysOfWeeks = this.invalidDateDaysOfWeeks;
                this.dateRangePickerOptions.isInvalidDate = function (date) {
                    return invalidDateDaysOfWeeks.includes(new Date(date).getDay());
                }
            }
        }
    }

    public initializeIMask(): void {
        if ((this.mask == null) && (!this.input.readOnly)) {
            this.mask = IMask(this.input, this.maskOptions);
        }
    }

    public initializeDateRangePicker() {
        if ((this.dateRangePicker == null) && (!this.input.readOnly)) {
            this.dateRangePicker = ($(this.input) as any).daterangepicker(this.dateRangePickerOptions);

            this.dateRangePicker.on("apply.daterangepicker", (ev, picker) => {
                const oldValue = this.input.value;

                let startTzDate = picker.startDate.toDate().getTime();
                startTzDate = startTzDate - picker.startDate.toDate().getTimezoneOffset() * 60000;
                let dateFrom = new Date(startTzDate);
                // If false is range
                if (picker.singleDatePicker) {
                    this.input.value = this.doFormatDate(dateFrom);
                    this.setDatesToDateRangePickerFromDates(dateFrom);
                } else {
                    let endTzDate = picker.endDate.toDate().getTime();
                    endTzDate = endTzDate - picker.endDate.toDate().getTimezoneOffset() * 60000;
                    let dateTo = new Date(endTzDate);
                    this.input.value = this.doFormatDatesFromTo(dateFrom, dateTo);
                    this.setDatesToDateRangePickerFromDates(dateFrom, dateTo);
                }

                if (oldValue !== this.input.value) {
                    this.dispatchEvent(new Event("change"));
                }
            });
        }
    }

    public doFormatDate(date: Date): string {
        let value = "";

        if (date != null) {
            value = this.getFormat().format(date);
            //Fix: Spanish format add ',' separating blocks, date and time: It´s not in our mask, so we will remove it
            value = value.replace(/, /g, " ");
        }
        return value;
    }

    public doFormatDatesFromTo(dateFrom: Date, dateTo: Date): string {
        let value = "";

        if (dateFrom != null) {
            value += this.doFormatDate(dateFrom);
        }

        value += this.separatorRange;

        if (dateTo != null) {
            value += this.doFormatDate(dateTo);
        }

        //Si solo queda el separador, se limpia todo el campo
        if (value === this.separatorRange) {
            value = "";
        }

        return value;
    }

    private setDatesToDateRangePickerFromDates(dateFrom: Date, dateTo?: Date) {
        this.dateRangePicker?.data("daterangepicker").setStartDate(dateFrom);
        if (this.dateRangePicker?.data("daterangepicker").singleDatePicker ?? false) {
            this.dateRangePicker?.data("daterangepicker").setEndDate(dateTo);
        }
    }

    public setDatesToDateRangePickerFromDateRange(dateRange: DateRangeData | DateRangeString) {
        let dateFrom: Date = (dateRange?.from != null) ? new Date(dateRange.from) : null;
        let dateTo: Date = (dateRange?.to != null) ? new Date(dateRange.to) : null;
        this.setDatesToDateRangePickerFromDates(dateFrom, dateTo);
    }

    public doFormatDateRange(dateRange: DateRangeData | DateRangeString): string {
        let dateFrom: Date = (dateRange?.from != null) ? new Date(dateRange.from) : null;
        let dateTo: Date = (dateRange?.to != null) ? new Date(dateRange.to) : null;
        return this.doFormatDatesFromTo(dateFrom, dateTo);
    }

    public disconnectedCallback() {
        this.dateRangePicker?.data("daterangepicker")?.remove();
        this.dateRangePicker = null;
    }

    public resetDatePicker() {
        if (this.dateRangePicker?.data("daterangepicker") != null) {
            this.disconnectedCallback();
            this.defineDateRangePickerOptions();
            this.initializeDateRangePicker();
        }
    }

    public set validationMessage(message) {
        if (message != null) {
            this.setAttribute("data-tip", message);
        }
    }

    public setClearButtonVisibility() {
        if (this.data == null || this.input.readOnly) {
            this.clearButton.style.visibility = "hidden";
        } else {
            this.clearButton.style.visibility = "visible";
        }
    }

    public set readOnly(ro: boolean) {
        const old = this.input.readOnly;
        this.input.readOnly = ro;
        this.calendarIcon.readOnly = ro;
        this.setClearButtonVisibility();
        if (ro && !old) {
            this.disconnectedCallback();
        }
        if (!ro && old) {
            this.defineDateRangePickerOptions();
            this.initializeDateRangePicker();
        }
    }

    public set valid(valid: boolean) {
        if (valid) {
            this.input.classList.remove("has-error");
            this.input.classList.remove("is-pending");
            this.removeAttribute("data-tip");
        } else {
            if (this.visited) {
                this.input.classList.add("has-error");
                this.input.classList.remove("is-pending");
            } else {
                this.input.classList.remove("has-error");
                this.input.classList.add("is-pending");
            }
        }
    }

    public abstract getFormat(): Intl.DateTimeFormat;

    public abstract defineDateRangePickerOptions(): any;

    public abstract defineIMaskOptions(): any;

    public abstract createRangesCalendar();

}

export interface DateRangeData {
    from: Date;
    to: Date;
}
export interface DateRangeString {
    from: string;
    to: string;
}

export interface DateTimeRangeData {
    from: Date;
    to: Date;
}
export interface DateTimeRangeString {
    from: string;
    to: string;
}
